'use strict';

exports.__esModule = true;
exports['default'] = computedProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _validators = require('../../utils/validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function computedProps(configs) {
  return function (Target) {
    (0, _validators.validateClass)(Target, 'bindProps');

    return function (props) {
      var newProps = Object.assign({}, props);
      Object.keys(configs).forEach(function (propName) {
        newProps[propName] = configs[propName];
      });
      return _react2['default'].createElement(Target, newProps);
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/components/bindProps.js
// module id = 543
// module chunks = 1